// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1DyLs","infoBtn":"quickbooks_infoBtn__2WYDE","formBox":"quickbooks_formBox__2kfCf","formFooter":"quickbooks_formFooter__EKWtg"};